import { IUserBalance } from "store/apis/balanceAPI/balance.types"
import { TAGS, api } from "../../api.ts"

export const balanceApi = api.enhanceEndpoints({ addTagTypes: [TAGS.BALANCE] })

export const balanceEndpoints = balanceApi.injectEndpoints({
  endpoints: (builder) => ({
    getBalance: builder.query<IUserBalance, void>({
      query: () => ({
        url: "/balance",
        method: "GET"
      }),
      providesTags: () => [{ type: TAGS.BALANCE, id: "balance" }]
    })
  })
})
